import React, { ButtonHTMLAttributes } from 'react';
import { useState, useEffect } from 'react';
import './button.css';

export interface IButton extends ButtonHTMLAttributes<HTMLButtonElement> {
    name: string;
}

function CentumButton({ name, ...props }: IButton) {
    return (
        <button className={`centum-button`} {...props}>
            {name}
        </button>
    );
}

export default CentumButton;
